import { data } from "./data"
import { TypedAccessor } from "./types"
import { Chip, ChipColor } from "../../../../components/base/informational/Chip"
import { WebUrl, webUrlToString } from "../../../../lib/webUrl"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type IdAccessorFn<T> = TypedAccessor<T, string | undefined>
type UrlAccessorFn<T> = TypedAccessor<T, WebUrl | string>
type ColorAccessorFn<T> = TypedAccessor<T, ChipColor>
type IdColumn<T> = Omit<DataColumn<T>, "type" | "renderCell">
interface IdColumnOptions<T> {
  accessorFn: IdAccessorFn<T>
  column?: IdColumn<T>
  chipColor?: ChipColor | ColorAccessorFn<T>
  path?: UrlAccessorFn<T>
}

export type IdColumnHelper<T> = (options: IdColumnOptions<T>) => DataColumn<T>

export function id<T>({
  accessorFn,
  column,
  chipColor = "blue",
  path,
}: IdColumnOptions<T>): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      if (typeof accessorFn !== "function") return null
      const id = accessorFn(rowData)
      if (!id) return null

      const color =
        typeof chipColor === "function" ? chipColor(rowData) : chipColor
      const rawHref = path?.(rowData)
      const href =
        typeof rawHref === "string"
          ? rawHref
          : rawHref && webUrlToString(rawHref)
      return <Chip color={color} text={id ?? "-"} href={href} />
    },
    title: column?.title ?? "ID",
    width: column?.width ?? TableCellWidth.Large,
  })
}
